import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';
import _BackButton from '../../../components/BackButton';
import Button from '../../../components/Button';
import { Chip } from '@material-ui/core';
import { FormBuilderIntegrationsContext } from '../engine/FormBuilderIntegrationsEngine';
import InputBase from '../../../components/form/InputBase';
import { TextString } from '../../../components/Text';
import _Tabs from '../../../components/engine/TabsEngine';
import Tab from '@material-ui/core/Tab';
import _Animation from '../../../components/Animation';
import DisconnectDialog from '../../GeneralDialog';
import EmailDialogEngine, {
  EMAIL_DIALOG_TYPES
} from '../../../components/engine/EmailDialogEngine';

const BackButton = styled(_BackButton)`
  && {
    align-self: baseline;
  }
`;

const BackButtonFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  button {
    margin-right: 1.5rem;
  }
`;

const Tabs = styled(_Tabs)`
  && {
    margin-bottom: 1.2em;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 0.8rem;
  justify-content: flex-end;
`;

const EditEmailButton = styled(Button)`
  width: 260px;
`;

const H2 = styled.h2`
  margin: 1.2rem 0 0.8rem;
  font-size: 18px;
`;

const AnimationContainer = styled.div`
  display: flex;
  min-height: 500px;
  overflow: hidden;
`;

const Animation = styled(_Animation)`
  && {
    width: 100%;
  }
`;

const SettingsPanel = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: 1000px;
`;

const LeftSide = styled.div`
  width: 60%;
`;

const RightSide = styled.div``;

const TitleDiv = styled.div`
  margin: 1rem 2rem;
`;

const TitleText = styled.span`
  font-size: 18px;
  font-weight: 600;
`;

const BodyDiv = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-left: 2rem;
`;

const ActiveChip = styled(Chip)`
  && {
    background: #d3e7dc;
    color: #0b773b;
    font-size: 14px;
    font-weight: 500;
    margin-left: 1rem;
  }
`;

const FormBuilderCredasView = props => {
  const t = useTranslations();
  const { setCurrentIntegrationPage } = useContext(
    FormBuilderIntegrationsContext
  );

  const { AUTHENTICATION: AUTHENTICATION_TAB, SETTINGS: SETTINGS_TAB } =
    props.TAB_VALUES;

  return (
    <Container>
      <SimpleFlexContainer>
        <BackButtonFlexContainer>
          <BackButton onClick={() => setCurrentIntegrationPage('')} />
          <TextString content="form-builder.integrations.credas.activate" />
        </BackButtonFlexContainer>
        <Tabs
          value={props.activeTab}
          onChange={(event, newValue) => props.setActiveTab(newValue)}
        >
          <Tab label={t(`form-builder.integrations.credas.authentication`)} />
          <Tab label={t(`form-builder.integrations.credas.settings`)} />
        </Tabs>
        <AnimationContainer>
          <Animation
            in={props.activeTab === AUTHENTICATION_TAB}
            mountOnEnter // very important
            unmountOnExit // very important
            type="slide"
            direction="right"
            timeout={{
              enter: 250,
              exit: 100
            }}
          >
            <H2>{t('form-builder.integrations.credas.api_key')}</H2>
            <InputBase
              variant="outlined"
              value={props.apiKey}
              onChange={e => props.setApiKey(e.target.value)}
              onFocus={() => {}}
              error={false}
              customCSS="width: 50% !important;"
            />
            <ButtonContainer>
              {props.credasConnected ? (
                <Button
                  onClick={() => props.setIsDisconnectDialogOpen(true)}
                  variant="outlined"
                  color="secondary"
                >
                  {t('form-builder.integrations.thirdfort.disconnect')}
                </Button>
              ) : (
                <Button onClick={props.onConnectBtnClicked}>
                  {t('form-builder.integrations.thirdfort.connect')}
                </Button>
              )}
            </ButtonContainer>
          </Animation>
          <Animation
            in={props.activeTab === SETTINGS_TAB}
            mountOnEnter // very important
            unmountOnExit // very important
            type="slide"
            direction="left"
            timeout={{
              enter: 250,
              exit: 100
            }}
          >
            <SettingsPanel>
              <LeftSide>
                <TitleDiv>
                  <TitleText>LOE Email</TitleText> <ActiveChip label="Active" />
                </TitleDiv>
                <BodyDiv>
                  This email is sent to the user named in the LEO-specific
                  user-look-up field and to the assigned user with the LEO
                  attached as a PDF.
                </BodyDiv>
              </LeftSide>
              <RightSide>
                <EditEmailButton
                  onClick={props.onEditLOETemplateClicked}
                  variant="outlined"
                >
                  Edit email
                </EditEmailButton>
              </RightSide>
            </SettingsPanel>
          </Animation>
        </AnimationContainer>
      </SimpleFlexContainer>
      <DisconnectDialog
        open={props.isDisconnectDialogOpen}
        title="form-builder.integrations.credas.disconnect_title"
        content="form-builder.integrations.credas.disconnect_explanation"
        variant="delete"
        buttons={[
          {
            text: 'dialog.cancel',
            variant: 'outlined'
          },
          {
            text: 'form-builder.integrations.credas.confirm_disconnect',
            color: 'secondary',
            onClick: 'confirm'
          }
        ]}
        handleConfirm={() => {
          props.onDisconnectBtnClicked();
        }}
        handleClose={() => props.setIsDisconnectDialogOpen(false)}
      />
      <EmailDialogEngine
        open={props.isEmailDialogOpen}
        handleConfirm={props.onEmailDialogConfirmed}
        handleClose={() => props.setIsEmailDialogOpen(false)}
        type={EMAIL_DIALOG_TYPES.TEMPLATE}
        templateId={props.templateId}
      />
    </Container>
  );
};

export default FormBuilderCredasView;
